/**
 * Utility functions for managing Planscreen endpoint
 * Returns the Laravel planscreen endpoint
 */

/**
 * Get the planscreen endpoint
 * @returns {string} 'planscreen'
 */
export const getPlanscreenEndpoint = () => {
    return 'planscreen';
};


